import { render } from "./ModalAssinaturaDigital.vue?vue&type=template&id=1677b476"
import script from "./ModalAssinaturaDigital.vue?vue&type=script&lang=js"
export * from "./ModalAssinaturaDigital.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__